module.exports = __webpack_public_path__ + "img/bg_wealth_top.664c5310.png";